import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../helpers/reducerRegistry'
import { handlePieChartData } from '../helper'
import { getYearOperation } from './thunk'

const initialState = {
  value: [],
  loading: false,
}

const slice = createSlice({
  name: 'portfolioInsights/segment/yearDistribution',
  initialState,
  reducers: {
    resetYearDistribution: (state) => {
      state.value = []
      state.loading = true
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getYearOperation.pending, (state) => {
      state.loading = true
    })
    builder.addCase(getYearOperation.fulfilled, (state, { payload }) => {
      state.value = handlePieChartData(payload) || []

      state.loading = false
    })
    builder.addCase(getYearOperation.rejected, (state, action) => {
      state.loading = action.payload.loading
    })
  },
})

export const { resetYearDistribution } = slice.actions

export const selectScoreYearOfOperation = (callback) => (state) => {
  const data = state[slice.name].value
  return callback ? callback(data) : data
}
export const selectLoading = (state) => state[slice.name].loading

register(slice.name, slice.reducer)
